import React, { useEffect, useState } from 'react'
import { Switch, Route, useLocation, useHistory } from 'react-router-dom'
import loadable from '@loadable/component'
import { entryAppLog, searchResultLog } from './lib/api/searchHistory/searchHistory'
import { useDispatch, useSelector } from 'react-redux'
import { setMember } from './store/member/memberSlice'
import { RootState } from './store/rootReducer'
import useNetwork from './hooks/useNetwork'
import NetworkError from './pages/NetworkError'
import { setDetailContents } from './store/wjpediaDetail/wjpediaDetailSlice'
import { setSearchWord } from './store/wjpedia/wjpediaSlice'

const MainPage = loadable(() => import('./pages/Main'))
const ListPage = loadable(() => import('./pages/List'))
const DetailPage = loadable(() => import('./pages/Detail'))
const AnnouncePage = loadable(() => import('./pages/Announce'))
const ThemePage = loadable(() => import('./pages/Theme'))
const PhotoDictPage = loadable(() => import('./pages/PhotoDictList'))
const PhotoDictDetailPage = loadable(() => import('./pages/PhotoDictDetail'))
const ModernDictPage = loadable(() => import('./pages/ModernPopup'))

const NotFoundPage = loadable(() => import('./pages/NotFound'))
// const ArtEventPage = loadable(() => import('./pages/Event/ArtEventPage'))
// const AudioEventPage = loadable(() => import('./pages/Event/AudioEventPage'))

function App() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  const [init, setInit] = useState(false)
  const onLine = useNetwork() // 네트워크 on/off 판단

  const { wjpedia } = useSelector((state: RootState) => ({
    wjpedia: state.wjpedia,
  }))
  const { member } = useSelector((state: RootState) => ({
    member: state.member,
  }))

  const isPrevMain = location.search.split('isPrevMain=')?.[1]?.split('&')[0] // 메인에서 넘어온 경우 true

  // 상세페이지에서 상세페이지로 링크 이동시 사용되는 전역 함수
  window.parent.fn_detailContInit = (
    dictSeq: string,
    headwq: string,
    dictIdx?: number,
    prevPage?: string
  ) => {
    if (dictIdx && dictIdx !== -1) {
      if (headwq === 'sense_no') {
        history.push(`/mobileWjdict/dict/${dictSeq}?dictIdx=${dictIdx}&sense_no=true`)
      } else {
        history.push(`/mobileWjdict/dict/${dictSeq}?dictIdx=${dictIdx}`)
      }
    } else {
      //console.log('fn_detailContInit', wjpedia)
      dispatch(setDetailContents(null))

      if (prevPage === 'theme') {
        history.push(`/mobileWjdict/dict/${dictSeq}?dictIdx=1`, { prevPath: '/mobileWjdict' })
      } else if (isPrevMain === 'true') {
        history.replace(`/mobileWjdict/dict/${dictSeq}?dictIdx=1&isPrevMain=true`)
      } else {
        history.push(`/mobileWjdict/dict/${dictSeq}?dictIdx=1`)
      }
    }
  }

  // 이 부분은 진짜 어쩔 수 없는 꼼수... 서버 오류 이미지(svg)가 제대로 안보이는 이슈를 해결하기 위해
  // 네트워크 오류 터지기 전에 미리 이미지를 불러오기 위함?
  useEffect(() => {
    setTimeout(() => {
      setInit(true)
    }, 10)
  }, [])

  // 고객 정보 파라미터가 있다면 불러와서 전역 저장 및 최초 진입로그
  useEffect(() => {
    let customerNumber = location.search.split('customerNumber=')[1]?.split('&')[0]
    let userSeq = location.search.split('userSeq=')[1]?.split('&')[0]
    let userName = location.search.split('userName=')[1]?.split('&')[0]
    let EXHIBITION_TP = location.search.split('EXHIBITION_TP=')[1]?.split('&')[0]

    dispatch(
      setMember({
        customerNumber: customerNumber,
        userSeq: userSeq,
        userName: userName,
      })
    )
    entryAppLog(userSeq, userName, EXHIBITION_TP)
  }, [dispatch])

  // 검색 로그
  useEffect(() => {
    const keyword = decodeURI(location.search.split('=')[1])
    if (!keyword) return
    if (wjpedia.wjpediaCnt.length > 0) {
      searchResultLog(member.userSeq, member.userName, wjpedia.searchWord, wjpedia.wjpediaCnt)
    }
  }, [wjpedia.wjpediaCnt])

  return (
    <>
      <Switch>
        <Route path="/mobileWjdict" component={MainPage} exact />
        <Route path="/mobileWjdict/dicts" component={ListPage} exact />
        <Route path={`/mobileWjdict/dict/:dictSeq`} component={DetailPage} exact />
        <Route path={`/mobileWjdict/announce/:announceId`} component={AnnouncePage} />
        <Route path={`/mobileWjdict/theme/:themeId`} component={ThemePage} />

        {/* 포토백과 라이트*/}
        <Route path={`/mobileWjdict/photoDicts`} component={PhotoDictPage} />
        <Route path={`/mobileWjdict/photoDict/:photoSeq`} component={PhotoDictDetailPage} />
        {/* 근현대사 필터페이지 */}
        <Route path={`/mobileWjdict/modernDict`} component={ModernDictPage} />
        {/* <Route path={`/mobileWjdict/event/1`} component={ArtEventPage} exact />
        <Route path={`/mobileWjdict/event/2`} component={AudioEventPage} exact /> */}

        <Route path="*" component={NotFoundPage} />
      </Switch>

      {/* <ServerError isError={!init || wjpedia.isError || wjpediaDetail.isError} /> */}
      {/* 네트워크 에러는 그냥 여기서 처리하는게...*/}
      <NetworkError isError={!init || !onLine} />
    </>
  )
}

export default App
